// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { formatNumberToUSD, getCardIconByCardType, getLast4Digits } from 'utils';
import { Grid, Icon, Typography } from '@material-ui/core';

const ReceiptPaymentField = ({ classes, payment, isNewStyle }) => {
  const { cardExpMonth, cardExpYear, networkType, subcardType, amount, keyIdentifier } = payment;
  const last4digits = getLast4Digits(payment);
  const expiryDate = cardExpMonth && cardExpYear ? `, Exp ${cardExpMonth}/${cardExpYear}` : '';
  const cardInfo = `${last4digits}${expiryDate}`;
  const isPLC = networkType === 'PLC';
  const cardType = isPLC && subcardType ? subcardType : networkType;
  const cardTypeIcon = getCardIconByCardType(cardType);

  return (
    <Grid container justifyContent="space-between" key={keyIdentifier}>
      <Grid item>
        <Grid container>
          <Icon className={classes.icon} component={cardTypeIcon} />
          <Typography
            className={isNewStyle ? classes.paymentLabel : null}
            variant="body2"
            color="textSecondary"
            gutterBottom
          >
            {cardInfo}
          </Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography
          variant="body2"
          color="textPrimary"
          gutterBottom
          className={isNewStyle ? classes.paymentValue : null}
        >
          {formatNumberToUSD(Math.max(0, amount))}
        </Typography>
      </Grid>
    </Grid>
  );
};

ReceiptPaymentField.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  isNewStyle: PropTypes.bool,
};

ReceiptPaymentField.defaultProps = {
  classes: {},
  isNewStyle: false,
};

export default ReceiptPaymentField;
